<template>
    <div
        class="cz2__steps-options__contact"
        :class="{
            'is-kiosk': isKiosk,
        }"
    >
        <img
            src="../assets/images/pop-yourself-logo.svg"
            alt="Pop! Yourself Logo"
            class="cz2__steps-options__contact__logo"
        >
        <img
            src="../assets/images/branded/sb-final/SB-POP_Yourself_Logo@2x.webp"
            alt="Pop! Yourself Logo"
            class="cz2__steps-options__contact__logo-sb"
        >

        <div
            ref="rendererPlaceholder"
            class="cz2__renderer-placeholder"
        />

        <!-- Need tighter spacer for these -->
        <div>
            <div class="cz2__step_options__contact__header">
                {{$t('STEP_CONTACT')}}
            </div>

            <div class="cz2__step_options__contact__description">
                <div v-html="$t('CONTACT_DESCRIPTION')" />
            </div>
        </div>

        <div class="cz2__steps-options__contact-inputs" :data-selected="selected">
            <div>
                <div class="cz2__input-box__label">
                    {{$t('CONTACT_NAME')}}
                </div>

                <base-input
                    :input-text="name"
                    :invalid="nameError"
                    :error-text="$t('CONTACT_NAME_ERROR')"
                    :small-font="false"
                    :maximum-length="32"
                    :read-only="true"
                    :outlined="selected === 'name'"
                    @focused="selectField('name')"
                    class="cz2__steps-options__contact-input"
                />
            </div>

            <div>
                <div class="cz2__input-box__label">
                    {{$t('CONTACT_PHONE')}}
                </div>

                <base-input
                    :input-text="phonePreview"
                    :invalid="!phoneValid || phoneError"
                    :error-text="$t('CONTACT_PHONE_ERROR')"
                    :small-font="false"
                    :maximum-length="32"
                    :read-only="true"
                    :outlined="selected === 'phone'"
                    @focused="selectField('phone')"
                    class="cz2__steps-options__contact-input"
                />
            </div>
        </div>

        <div class="cz2__steps-options__contact-keyboard">
            <keyboard
                v-model="text"
                :layouts="layouts"
            />
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        // Contact step is only used on the Kiosk.
        .cz2__steps-options__contact__logo-sb {
            display: none;
        }

        .cz2__steps-options__contact {
            // position: absolute;

            // left: 0;
            // top: 0;

            pointer-events: auto;

            padding: var(--layout-spacing);
            padding-bottom: var(--steps-options-nav-height);

            width: 100%;
            height: 100%;
            @include bg(gradientBlue);

            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 40px;

            .cz2__renderer-placeholder {
                margin-top: 165px;

                width: 100%;
                flex: 1 1 0%;
            }
        }

        .cz2__steps-options__contact__logo {
            position: absolute;

            top: 24px;
            right: 24px;

            width: 222px;
            height: 195px;

            z-index: 99;
        }

        .cz2__input-box__label {
            margin-bottom: 8px;

            font-family: var(--cz-font-900-family);
            font-weight: var(--cz-font-900-weight);
            font-size: 28px;
            line-height: 28px;
            letter-spacing: -0.3px;
            text-transform: none;

            color: #fff;

            transition: all $transition-fast ease-out;
        }

        .cz2__steps-options__contact-inputs {
            width: 900px;

            margin-top: 16px;
            margin-bottom: 40px;

            display: flex;
            justify-content: center;

            gap: 28px;

            > div {
                flex: 1 0 0;
            }
        }

        .cz2__step_options__contact__header {
            color: color(primaryWhite);
            @include font(h1);
            text-align: center;

            font-size: 54px;
            line-height: 54px;
        }

        .cz2__step_options__contact__description {
            margin-top: 8px;
            padding: 0 80px;

            color: color(primaryWhite);
            @include font(bodyRegular);
            text-align: center;

            font-size: 24px;
            line-height: 32px;
        }

        .cz2__steps-options__contact-keyboard {
            min-height: 400px;

            margin-bottom: 80px;
        }
    }

    #cz2.cz2__is-sb {
        .cz2__step_options__contact__header, .cz2__step_options__contact__description,
        .cz2__input-box__label {
            color: #000;
        }

        .cz2__steps-options__contact__logo {
            display: none;
        }
        .cz2__steps-options__contact__logo-sb {
            display: block;
            position: absolute;
            top: 56px;
            right: 56px;
        }
    }

    #cz2.cz2__is-sb.cz2__is-kiosk.cz2__is-contact-step {
        .cz2__steps {
            @include bg(transparent);
        }
        .cz2__input-box {
            box-shadow: none;
        }
        .cz2__customizer {
            background-image: url('../assets/images/branded/sb-final/SB-Background-pattern-2_D@2x.jpg');
            background-size: contain;
        }
        .cz2__renderer {
            z-index: 1;
        }
        .cz2__steps-options__contact {
            padding: 50px 50px 80px;

            @include respond-above(sm) {
                padding: 90px 0 130px;
            }

            background-size: 50%;
            background-position: center;
            background-repeat: repeat;

            &.cz2__steps-options__name--sb-type-none {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-G {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-G@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-H {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-H@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-S {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-S@2x.jpg');
                }
            }

            &.cz2__steps-options__name--sb-type-R {
                background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                @include respond-above(sm) {
                    background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-3_D_Attach-Pack-Image-R@2x.jpg');
                }
            }

            background-size: cover;

            background-image: none;
            background-color: transparent;

            position: absolute;
            border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_M@2x.webp');

            border-width: 40px;
            border-image-width: 40px;
            border-image-slice: 80 fill;
            border-image-repeat: stretch;

            height: calc(100% - var(--steps-options-nav-height-sb));
            width: 100%;

            @include respond-above(lg) {
                border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_D@2x.webp');
                // height: 100%;
                width: 100%;
                border-width: 70px;
                border-image-width: 70px;
                border-image-slice: 140 fill;
                border-image-repeat: stretch;
            }
        }
        .cz2__sb-logo__name-m, .cz2__sb-logo__name-d {
            display: none;
        }

        .cz2__sb-logo__name-k {
            display: block;
            height: 180px;
            margin-top: 32px;
        }
        .cz2__main-navigation-button {
            margin-top: 24px;
        }

        .cz2__input-box {
            margin-bottom: 24px;
        }

        .cz2__steps-options__navigation--name {
            bottom: 0;
        }
    }
</style>

<script>
    import { AsYouType, isValidPhoneNumber } from 'libphonenumber-js';

    import Keyboard from './ui/Keyboard.vue';
    import StepHeader from './ui/StepHeader.vue';

    import MainNavigation from './MainNavigation.vue';
    import BaseInput from './ui/BaseInput.vue';

    export default {
        components: {
            Keyboard,
            StepHeader,
            MainNavigation,
            BaseInput,
        },

        data() {
            return {
                name: this.$store.state.customizer.contactName,
                phone: this.$store.state.customizer.contactPhone,
                text: this.$store.state.customizer.contactName,
                selected: 'name',
                nameError: false,
                phoneError: false,
            };
        },

        computed: {
            options() {
                return this.$store.state.customizer.options;
            },

            isKiosk() {
                return this.options && this.options.isKiosk;
            },

            contactName() {
                return this.$store.state.customizer.contactName;
            },

            contactPhone() {
                return this.$store.state.customizer.contactPhone;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            layouts() {
                if (this.selected === 'name') {
                    return [
                        '1234567890{DELETE:backspace}|QWERTYUIOP_|ASDFGHJKL-+|{SHIFT:goto:1}ZXCVBNM,.@|{:space}',
                        '!@#$%^&*(){DELETE:backspace}|ÁÉÍÓÚÜÑ¿¡ _|         -+|{SHIFT:goto:0}       ,.@|{:space}',
                    ];
                }

                if (this.selected === 'phone') {
                    return [
                        '123|456|789|0{DELETE:backspace}',
                    ];
                }

                return [
                    '1234567890{DELETE:backspace}|QWERTYUIOP_|ASDFGHJKL-+|{SHIFT:goto:1}ZXCVBNM,.@|{:space}',
                    '!@#$%^&*(){DELETE:backspace}|ÁÉÍÓÚÜÑ¿¡ _|         -+|{SHIFT:goto:0}       ,.@|{:space}',
                ];
            },

            phonePreview() {
                return new AsYouType('US').input(this.phone || '');
            },

            phoneValid() {
                return (this.phone || '').length > 0 ? isValidPhoneNumber(this.phone, 'US') : true;
            },

            phoneEntered() {
                return (this.phone || '').length > 0 ? isValidPhoneNumber(this.phone, 'US') : false;
            },

            nameEntered() {
                return (this.name || '').length > 0;
            },
        },
        watch: {
            name() {
                this.$store.dispatch('uiInteracted');
            },

            phone() {
                this.$store.dispatch('uiInteracted');
            },

            nameEntered() {
                this.updateNavigation();
            },

            phoneEntered() {
                this.updateNavigation();
            },

            text() {
                if (this.selected === 'name') {
                    this.nameError = false;

                    this.name = this.text;
                    this.$store.dispatch('updateContactName', this.name);
                }

                if (this.selected === 'phone') {
                    this.phoneError = false;

                    this.phone = this.text;
                    this.$store.dispatch('updateContactPhone', this.phone);
                }
            },
        },

        mounted() {
            this.updateNavigation();

            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'contact',
                placeholder: this.$refs.rendererPlaceholder,
            });
        },

        beforeDestroy() {
            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'contact',
            });
        },

        methods: {
            updateNavigation() {
                this.$emit('updateNavigation', {
                    hasBack: true,
                    canGoBack: true,
                    hasNext: true,
                    nextPressed: this.nextPressed,
                    canGoNext: true,
                    showNextDisabled: !this.phoneEntered || !this.nameEntered,
                    nextSpecial: 'Checkout',
                    previousSpecial: 'Name',
                });
            },

            nextPressed() {
                if (!this.nameEntered) {
                    this.nameError = true;

                    if (this.phoneEntered) {
                        this.selectField('name');
                    }

                    return false;
                }

                if (!this.phoneEntered) {
                    this.phoneError = true;

                    if (this.nameEntered) {
                        this.selectField('phone');
                    }

                    return false;
                }

                return true;
            },

            selectField(f) {
                this.selected = f;

                if (f === 'name') {
                    this.text = this.name;
                }

                if (f === 'phone') {
                    this.text = this.phone;
                }
            },
        },
    };
</script>
